import { addRumError } from '@/integrations/datadog/init';

export function captureError(error: unknown, context?: Record<string, unknown>) {
  const err = error instanceof Error ? error : new Error(String(error));
  addRumError(err, context);
}

export function capturePromise<T>(promise: Promise<T>, context?: Record<string, unknown>): Promise<T> {
  return promise.catch((error) => {
    captureError(error, context);
    throw error;
  });
}

type ServiceErrorCode = 'NOT_FOUND' | 'CONFLICT' | 'VALIDATION' | 'UNAUTHORIZED' | 'UNKNOWN';

export class ServiceError extends Error {
  code: ServiceErrorCode;
  originalError?: unknown;

  constructor(message: string, code: ServiceErrorCode, originalError?: unknown) {
    super(message);
    this.name = 'ServiceError';
    this.code = code;
    this.originalError = originalError;
  }
}

interface WithTrackingOptions {
  service: string;
  operation: string;
}

export function withErrorTracking<TArgs extends unknown[], TResult>(
  fn: (...args: TArgs) => Promise<TResult>,
  options: WithTrackingOptions,
): (...args: TArgs) => Promise<TResult> {
  return async (...args: TArgs): Promise<TResult> => {
    try {
      return await fn(...args);
    } catch (error) {
      captureError(error, { service: options.service, operation: options.operation });

      if (error instanceof ServiceError) throw error;

      const message = error instanceof Error ? error.message : 'Erro inesperado';
      throw new ServiceError(message, 'UNKNOWN', error);
    }
  };
}
